/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import {Switch, Route, useRouteMatch, useParams, Redirect} from 'react-router-dom';

import FinancialPlanInfo from './FinancialPlanInfo';
import FinancialPlanStages from './FinancialPlanStages';
import FinancialPlanStagesSummary from './FinancialPlanStagesSummary';

const FinancialPlanRoute = ({t, userId, financialPlan}) => {
  const {url} = useRouteMatch();
  const { finplanId } = useParams();

  const [openCreateStageModal, setOpenCreateStageModal] = useState(null);

  return (
    <Switch>
        <Route path={`${url}/stages/:stageId`}>
          <FinancialPlanStagesSummary
            t={t}
            financialPlan={financialPlan}
            finplanId={finplanId}
            userId={userId}
            openCreateStageModal={openCreateStageModal}
            setOpenCreateStageModal={setOpenCreateStageModal}
          />
        </Route>
        <Route path={`${url}/stages`}>
          <FinancialPlanStages
            t={t}
            finplanId={finplanId}
            financialPlan={financialPlan}
            userId={userId}
            openCreateStageModal={openCreateStageModal}
            setOpenCreateStageModal={setOpenCreateStageModal}
          />
        </Route>
        <Route path={`${url}/`}>
          <FinancialPlanInfo
            t={t}
            finplanId={finplanId}
            financialPlan={financialPlan}
            userId={userId}
          />
        </Route>
        <Route exact path='*'>
          <Redirect to={`${url}`}/>
        </Route>

    </Switch>
  );
};

export default FinancialPlanRoute;

FinancialPlanRoute.propTypes = {
    t: PropTypes.func,
    financialPlan: PropTypes.object,
    userId: PropTypes.string,
};